import axios from 'axios'

const http = axios.create({
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
  timeout: 30000,
  transformResponse: [(data) => {
    if (typeof data === 'string' && data.startsWith('{')) {
      data = JSON.parse(data)
    }
    return data
  }]
})

http.interceptors.response.use(function (response) {
  if (response?.data?.code === 0) {
    return Promise.resolve(response?.data.data)
  } else {
    return Promise.reject({
      message: response?.data?.message || 'Unknown error'
    })
  }
}, function (error) {
  // const message = `Error ${String(error?.response?.status ?? '500')}: Things are a little unstable here, I suggest come back later`

  return Promise.reject(error)
})

/**
 * 
 * @param {object} http - 请求实体
 * @param {object} config - 初始化配置
 * @param {string} config.url 
 * @param {'GET' | 'PUT' | 'POST' | 'DELETE' | 'PATCH'} config.method 
 * @param {(data: string | Object) => Object} [middleware] - 发起请求前处理传入参数的中间件
 * @returns 
 */
export function registerAPI(http, config, middleware) {
  const _middleware = middleware || function (data) {
    return data
  }
  let controller = null
  let time = 0

  /**
   * Logs the request information to the console.
   *
   * @param {Object} data - The data to be logged.
   */
  const requestLog = (data) => {
    const now = Date.now()
    console.table({
      'request': config.url,
      'method': config.method,
      'request time (ms)': now,
      'last request time (ms)': time,
      'interval (ms)': now - time,
      'data': JSON.stringify(data),
    })
    time = now

    return now
  }

  return {
    /**
     * Sends a request with the given data.
     *
     * @param {Object | string} data - The data to be sent in the request.
     * @return {Promise} A promise that resolves with the response data.
     */
    request: (data) => {
      const _data = _middleware(data)
      const _controller = new AbortController()
      const _config = {
        ...config,
        signal: _controller.signal,
      }

      controller = _controller

      if (_config.method === 'GET') {
        _config.params = _data
      }
  
      if (['PUT', 'POST', 'DELETE', 'PATCH'].includes(_config.method)) {
        _config.data = _data
      }

      requestLog(_data)
      return http(_config).finally(() => {
        // 清理前需要判断引用是否发生变化
        // 如果全局变量已被覆盖，那么就不需要清理
        if (_controller === controller) {
          console.log('request end:', _config.url)
          controller = null
        }
      })
    },
    /**
     * Abort the current request if it is in progress.
     *
     * @return {undefined} No return value.
     */
    abort: () => {
      if (controller) {
        console.warn('abort request:', config.url)
        controller.abort()
        controller = null
      }
    },
  }
}

export default http
